import * as passwordValidator from "password-validator";
import { SimpleCrypt } from "ngx-simple-crypt";
import { environment } from "../../environments/environment";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import { AuthService } from "../auth/auth.service";
const cryptr = new SimpleCrypt();

export let TableMessage = {
  emptyMessage: "No data to display",
  totalMessage: "total",
};

export function translateTableMessages(transService) {
  // console.log('translateTableMessages');
  return (
    (TableMessage.emptyMessage = transService.instant("612")),
    (TableMessage.totalMessage = transService.instant("16"))
  );
}

export function SortObjectArrayByArg(array: any[], arg: string) {
  // transform(array: Array<string>, args: string): Array<string> {
  array.sort((a: any, b: any) => {
    if (a[arg] < b[arg]) {
      return -1;
    } else if (a[arg] > b[arg]) {
      return 1;
    } else {
      return 0;
    }
  });
  return array;
}

export function SortObjectArrayByArgDesc(array: any[], arg: string) {
  // transform(array: Array<string>, args: string): Array<string> {
  array.sort((a: any, b: any) => {
    if (a[arg] > b[arg]) {
      return -1;
    } else if (a[arg] < b[arg]) {
      return 1;
    } else {
      return 0;
    }
  });
  return array;
}

export function objectPositionMove(arr, from, to) {
  return arr.reduce((prev, current, idx, self) => {
    if (from === to) {
      prev.push(current);
    }
    if (idx === from) {
      return prev;
    }
    if (from < to) {
      prev.push(current);
    }
    if (idx === to) {
      prev.push(self[from]);
    }
    if (from > to) {
      prev.push(current);
    }
    return prev;
  }, []);
}

export function findObectInArray(myArray: any[], field: string, val: any) {
  return myArray.find((rec) => rec[field] === val);
}

export function findObjectIndexInArray(
  myArray: any[],
  field: string,
  val: any
) {
  return myArray.findIndex((rec) => rec[field] === val);
}

export function padLeft(nr, n, str) {
  return Array(n - String(nr).length + 1).join(str || "0") + nr;
}

export function generateID(length: number = 12) {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  // return '_' + Math.random().toString(36).substr(2, 20);
  return Math.round(
    Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)
  )
    .toString(36)
    .slice(1);
}

export function AddRemoveYear(
  myArray: number[],
  yearVal: number,
  isRemove: boolean
) {
  let iPos: number = -1;
  // console.log('years begin' );
  for (let iFor = 0; iFor < myArray.length; iFor++) {
    if (myArray[iFor] === yearVal) {
      iPos = iFor;
      break;
    }
  }
  // iPos = myArray.findIndex( yearVal );
  if (isRemove) {
    if (iPos > -1) {
      myArray.splice(iPos, 1);
    }
  } else {
    if (iPos === -1) {
      myArray.push(yearVal);
      myArray.sort();
    }
  }

  // console.log('years', myArray);
  return myArray;
}

export function validateNitRut(sNit: string) {
  let isValid: boolean = true;
  const cPrime: number[] = [
    3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71,
  ];
  let iPrimePos, iVer, iLength, iSum: number;
  let sNit2, sDigitVer: string;

  try {
    let nitnum: number = +sNit;
  } catch (err) {
    isValid = false;
  }
  // console.log('validateNitRut 1', isValid);
  if (isValid) {
    iSum = 0;
    iPrimePos = 0;
    sDigitVer = sNit.substr(sNit.length - 1, 1);
    sNit2 = sNit.substr(0, sNit.length - 1);
    iLength = sNit2.length;
    if (iLength < 9) {
      for (let iFor = 0; iFor < 8 - iLength; iFor++) {
        sNit2 = "0" + sNit2;
      }
    }

    for (let iFor = sNit2.length; iFor > 0; iFor--) {
      try {
        iSum = iSum + +sNit2[iFor - 1] * cPrime[iPrimePos];
        iPrimePos = iPrimePos + 1;
      } catch (err) {}
    }
    iVer = iSum % 11;
    if (iVer >= 2) {
      iVer = 11 - iVer;
    }
    isValid = sDigitVer === iVer + "";
  }
  return isValid;
}

export function dateAddTimeZone(dateIn: Date): Date {
  dateIn.setTime(dateIn.getTime() + dateIn.getTimezoneOffset() * 60 * 1000);
  return dateIn;
}
export function dateAddMinutes(date, minutes) {
  return new Date(date.getTime() + minutes * 60000);
}

export function dateAddDay(date, days) {
  const nDate = new Date(date);
  nDate.setDate(nDate.getDate() + days);
  return nDate;
}

export function getMonthStr(nd: Date) {
  if (nd) {
    const nd2: Date = new Date(nd);
    let m0: string = "";
    let month: number = nd2.getMonth() + 1;
    if (month < 10) {
      m0 = "0";
    }
    return m0 + month;
  } else {
    return null;
  }
}

export function getYearStr(nd: Date) {
  if (nd) {
    const nd2: Date = new Date(nd);
    return nd2.getFullYear() + "";
  } else {
    return null;
  }
}

export function dateFormatToStr(nd: Date, separetor: string = "/") {
  if (nd) {
    const nd2: Date = new Date(nd);
    let m0: string = "";
    let d0: string = "";
    let month: number = nd2.getMonth() + 1;
    let day: number = nd2.getDate();
    if (month < 10) {
      m0 = "0";
    }
    if (day < 10) {
      d0 = "0";
    }
    return nd2.getFullYear() + separetor + m0 + month + separetor + d0 + day;
  } else {
    return null;
  }
}

export function timeFormatToStr(nd: Date, separetor: string = ":") {
  if (nd) {
    const nd2: Date = new Date(nd);
    let h0: string = "";
    let m0: string = "";
    let hour: number = nd2.getHours();
    let min: number = nd2.getMinutes();
    if (hour < 10) {
      h0 = "0";
    }
    if (min < 10) {
      m0 = "0";
    }
    return h0 + hour + separetor + m0 + min + separetor + "00";
  } else {
    return null;
  }
}

export const monthsESP = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];
export function getMonthEsp(month): string {
  return monthsESP[month - 1];
}

export function dateGetDayOfWeek(dateS: string): number {
  const tDT = new Date(dateS);
  tDT.setTime(tDT.getTime() + tDT.getTimezoneOffset() * 60 * 1000);
  return tDT.getDay();
}

export function sleepMS(milliseconds) {
  var start = new Date().getTime();
  for (var i = 0; i < 1e7; i++) {
    if (new Date().getTime() - start > milliseconds) {
      break;
    }
  }
}

export function getOnlyInterfacekeys<ToInterface>(val: any) {
  // console.log('keysOfInt', keysOfInt);
}

export function VerifyIfObjectIsNotNull(object: any, field: string): boolean {
  if (!object) {
    return false;
  } else {
    try {
      if (object[field]) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      return false;
    }
  }
}

export function makeRandomId(lenght: number) {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < lenght; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}
//
//
// function onlyInterfaceExisting<T, K extends keyof T>(obj: T, ...keys: K[]): Pick<T, K> {
//   const copy = {} as Pick<T, K>;
//
//   keys.forEach(key => copy[key] = obj[key]);
//
//   return copy;
// }

export function preparePasswordValid() {
  let schema = new passwordValidator();
  return schema
    .is()
    .min(6) // Minimum length 6
    .is()
    .max(12) // Maximum length 12
    .has()
    .uppercase() // Must have uppercase letters
    .has()
    .lowercase() // Must have lowercase letters
    .has()
    .digits() // Must have digits
    .has()
    .not()
    .spaces() // Should not have spaces
    .is()
    .not()
    .oneOf(["Passw0rd", "Password123"]); // Blacklist these values
}

export function stripAccents(str) {
  var reAccents = /[àáâãäçèéêëìíîïñòóôõöùúûüýÿÀÁÂÃÄÇÈÉÊËÌÍÎÏÑÒÓÔÕÖÙÚÛÜÝ]/g;
  var replacements = "aaaaaceeeeiiiinooooouuuuyyAAAAACEEEEIIIINOOOOOUUUUY";
  return str.replace(reAccents, function (match) {
    return replacements[reAccents.source.indexOf(match)];
  });
}

export function verIfNotNullOrUndefined(val) {
  return val !== null && val !== undefined;
}

export function decodeValueUrl(val: string) {
  return cryptr.decode("I3RS#AT$", val);
}

export function getapiUrlInterceptVer() {
  if (environment.production) {
    return window.location.origin;
  } else {
    return environment.apiUrlInterceptVer;
  }
}
